// extracted by mini-css-extract-plugin
export default {"skillItem":"styles_skillItem__SIfQy"};